var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full h-full" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.group, loading: _vm.$apollo.loading } },
        [
          !!_vm.group
            ? _c("GroupHeader", {
                attrs: {
                  archived: _vm.group.archived,
                  groupName: _vm.group.name,
                  groupLocation: _vm.group.location,
                  companyId: _vm.company.id,
                  currentUserId: _vm.currentUser.id,
                  contractors: _vm.group.contractors,
                  managers: _vm.group.managers,
                  currentUserRole: _vm.currentUser.role,
                },
                on: {
                  archived: _vm.handleGroupArchived,
                  activated: _vm.handleGroupActivated,
                },
              })
            : _vm._e(),
          _c("TabsWithRoutes", { attrs: { routeTabs: _vm.routeTabs } }),
          _c("router-view", {
            attrs: {
              company: _vm.company,
              companyId: _vm.company.id,
              currentUser: _vm.currentUser,
              group: _vm.group,
              contractors: _vm.contractors,
              managers: _vm.managers,
              skills: _vm.skills,
              projects: _vm.projects,
              postings: _vm.postings,
              groupId: _vm.groupId,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }